import consumer from '../../index';

const LiveFeedChannel = (rider_id) => {
  return consumer.subscriptions.create({
    channel: 'RiderFeedChannel',
    rider_id: rider_id,
  });
};

export default LiveFeedChannel;
